import React from 'react'
import classNames from 'classnames'
import { Form } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'

export const MAX_USER_QUESTION_LENGTH = 350

interface CrossClientQueryInputProps {
  userQuestion: string
  onQuestionChange: (question: string) => void
  onSubmit: () => Promise<void>
  disabled: boolean
  submitDisabled: boolean
  isLoading: boolean
  hasExecution: boolean
  noRemainingQueries: boolean
}

export const CrossClientQueryInput = ({
  userQuestion,
  onQuestionChange,
  onSubmit,
  disabled,
  submitDisabled,
  isLoading,
  hasExecution,
  noRemainingQueries,
}: CrossClientQueryInputProps) => {
  const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (isLoading || hasExecution) {
      return
    }
    if (e.key === 'Enter') {
      e.preventDefault()
      if (e.ctrlKey || e.metaKey) {
        onQuestionChange(`${userQuestion}\n`)
      } else if (!submitDisabled) {
        await onSubmit()
      }
    }
  }

  return (
    <div className='d-flex gap-3'>
      <Form.Control
        className={classNames('p-0 border-0 cross-client-input-textarea', { 'zocks-bg-color-gray-200': noRemainingQueries })}
        as='textarea'
        value={userQuestion}
        maxLength={MAX_USER_QUESTION_LENGTH}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          onQuestionChange(e.currentTarget.value)
        }}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        placeholder='Example: Which clients are approaching retirement with over $500k in assets?'
      />

      {!isLoading && !hasExecution ? (
        <Button
          variant='borderless'
          className={classNames('button-medium px-0 align-items-end cross-client-landing-button', {
            'zocks-bg-color-gray-200': noRemainingQueries,
          })}
          onClick={onSubmit}
          disabled={submitDisabled}
        >
          <i className='bi bi-arrow-right-circle-fill fs-2' />
        </Button>
      ) : null}
    </div>
  )
}
